import React from 'react';

import {useAppDispatch, useAppSelector} from '../../../../redux';
import {useStore} from 'react-redux';
import {reduxForm, formValueSelector, change} from 'redux-form';
import format from 'date-fns/format';
import {Forms} from '../../../../shared/models/forms';
import View from './view';
import {FilterForm, ViewProps, Props} from './model';
import {dateFormats, dateNewsFrom, dateNewsTo} from '../../../../shared/constants/date';
import {applyNewsFilter} from '../../../../redux/actions/news';
import {setFilterModalVisible} from '../../../../redux/actions/runtime/news';
import {defaults} from '../../../../shared/constants/defaults';

const Form = reduxForm<FilterForm, ViewProps>({form: Forms.newsFilter, destroyOnUnmount: false})(View);
const selector = formValueSelector(Forms.newsFilter);

export const Filter = (viewProps: Props) => {
  const dispatch = useAppDispatch();
  const store = useStore();
  const formData: FilterForm = useAppSelector((state) => selector(state, 'from', 'to', 'all'));

  const onSubmit = React.useCallback(() => {
    const latestFormData: FilterForm = selector(store.getState() as any, 'from', 'to', 'all');
    const fromDate = latestFormData.from;
    const toDate = latestFormData.to;
    const params = latestFormData.all
      ? undefined
      : {
          from: format(fromDate, dateFormats.apiDate),
          to: format(toDate, dateFormats.apiDate),
          perPage: defaults.newsPageSize,
        };

    dispatch(applyNewsFilter(params));
    dispatch(setFilterModalVisible(false));
  }, [dispatch, store]);

  const onShowAllChange = React.useCallback(
    (value: any) => {
      if (value) {
        dispatch(change(Forms.newsFilter, 'from', dateNewsFrom));
        dispatch(change(Forms.newsFilter, 'to', dateNewsTo));
      }
    },
    [dispatch],
  );

  const onDateChange = React.useCallback(() => {
    dispatch(change(Forms.newsFilter, 'all', false));
  }, [dispatch]);

  const onClose = () => dispatch(setFilterModalVisible(false));

  // Не возвращаем null, даже если форма не инициализирована - пусть redux-form обработает это
  // Поля все равно должны отображаться, даже если значения еще не загружены
  return React.createElement(Form, {formData, onSubmit, onShowAllChange, onDateChange, onClose, ...viewProps});
};
